export const GET_ALL_PERSON = "GET_ALL_PERSON";
export const CREATE_PERSON = "CREATE_PERSON";
export const GET_PERSON_BY_UUID = "GET_PERSON_BY_UUID"
